import { PayloadAction } from '@reduxjs/toolkit';

import { StationsState } from '../../types';

export const setRouteStationsWithPrices = (
  state: StationsState,
  action: PayloadAction<StationsState['routesStationsWithPrices']['data']>
) => {
  state.routesStationsWithPrices.data = (action.payload || []).sort((firstStation, secondStation) => (
    firstStation.stationCode.toLowerCase() > secondStation.stationCode.toLowerCase() ? 1 : -1
  ));
};